import EscPos from "@/shared/helpers/EscPos";
import {formatDateTimeWithSeconds, getLocalDateFromServer} from "@/shared/helpers/dates";

export function buildPosReceiptEscPos(business, transaction, currencyCode = "EUR") {
	const esc = EscPos.init();

	let result = esc.justifyCenter(esc.replaceUnprintableChars(business?.name || ""));
	if (business?.address) {
		if (business.address.via && business.address.civico && business.address.comune && business.address.zip && business.address.provincia_codice) {
			result += esc.justifyCenter(esc.replaceUnprintableChars(business.address.via + " " + business.address.civico));
			result += esc.justifyCenter(esc.replaceUnprintableChars(business.address.zip + " " + business.address.comune + " (" + business.address.provincia_codice + ")"));
		} else if (business.address.address) {
			result += esc.justifyCenter(esc.replaceUnprintableChars(business.address.address));
		}
	}
	if (business?.vat) {
		result += esc.justifyCenter("P.IVA " + business.vat);
	}
	result += "\n";

	result += esc.justifyCenter("RICEVUTA");
	result += esc.justifyCenter("per pagamento elettronico");
	result += "\n";

	let qromoRefWord = esc.columns() > 32 ? "Rif.Qromo" : "Rif.";

	result += esc.fixedRight("Tipologia", transaction.receipt_account_type || "-", false);
	result += esc.fixedRight("App.Crypt.", transaction.receipt_application_cryptogram || "-", false);
	result += esc.fixedRight("App.", transaction.receipt_application_preferred_name || "-", false);
	result += esc.fixedRight("Aut.", transaction.receipt_authorization_code || "-", false);
	result += esc.fixedRight("Aut.Resp", transaction.receipt_authorization_response_code || "-", false);
	result += esc.fixedRight("Met.Verif.", transaction.receipt_cardholder_verification_method || "-", false);
	result += esc.fixedRight("File", transaction.receipt_dedicated_file_name || "-", false);
	result += esc.fixedRight("Verif.Res.", transaction.receipt_terminal_verification_results || "-", false);
	result += esc.fixedRight("Stato", transaction.receipt_transaction_status_information || "-", false);
	result += esc.fixedRight(qromoRefWord, transaction.payment_intent_id || "-", false, true);
	result += esc.separator();

	let date = getLocalDateFromServer(transaction.date);
	result += esc.fixedRight("Data e Ora", formatDateTimeWithSeconds(date, false), false);
	result += "\n";

	let amountStr = transaction.amount ? (Number(transaction.amount) / 100).toFixed(2).replace(".", ",") : "-";
	amountStr += " " + (currencyCode || "EUR");
	let amountWord = esc.columns() > 32 ? "Importo" : "Tot";
	result += esc.fixedRight(amountWord, amountStr, true, true);

	result += "\n\n";
	result += esc.justifyCenter("Powered by QROMO");
	result += "\n\n\n\n\n\n";
	result += "\x1d\x56\x31";

	return result;
}
